import {useState, useEffect }from 'react';
import { genConfig } from 'react-nice-avatar'; 
import inputConfigMap from '@/components/inputTypeConfig';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import {IconPlayerPlay } from "@tabler/icons-react";

const  UseTools = ({isToggle, OnToggle}) => {
    
    const location = useLocation()
	const navigate = useNavigate()
	const { id } = useParams();
	const [tools, setTools ] = useState(location?.state?.tools);
    const [parseTools, setParseTools] = useState<any>(null);
    const config = genConfig(id);
    useEffect(() => {
      if (tools?.flowData) {
        // Parse flowData and store it in state
        const parsedData = JSON.parse(tools.flowData);
        setParseTools(parsedData);
      }
    }, [tools]);

    const onChange = (id: string, value: any) => {
        // Update the specific item in inputData based on its id
        const updatedData = parseTools.inputData.map((item) =>
          item.id === id ? { ...item, testValue: value } : item
        );
        
        setParseTools({ ...parseTools, inputData: updatedData });
      };
   
    return (
        <>
        <div className={`flex ${isToggle ? 'h-full' : 'mx-60'} `}>

            
            <div className="card border border-gray-200 rounded-lg bg-white w-full md:px-8 md:py-4 ">
                <div>
                <h3 className="agent-title">
                 {tools?.tool_name || "Untitled tool"}
                </h3>
                    <p className="text-sm text-muted-foreground line-clamp-2">
                    {parseTools?.overview?.description || "AI powered tool"}
                </p>
             </div>
             
                <div className="mt-4">
                {parseTools && parseTools?.inputData?.map((item, index) => {
                   
                    // Dynamically select the component based on item.type
                    const Component = inputConfigMap[item.type] || inputConfigMap['Text Input'];
                    return (
                        <div key={index}>
                            <h3 className="font-semibold text-lg px-1 py-2">{item?.title || item?.inputText} <span className='text-red-500'>*</span></h3>
                            <Component item={item} onChange={(value: any) => onChange(item.id, value)} />
                        </div>
                    );
                })}   
                </div>
                <div className='w-full mt-4'>

                <Button className='w-full' color='outline' onClick={OnToggle} disabled={isToggle}><IconPlayerPlay className='mr-2' /> Run Tool</Button>
                </div>
            </div>
        </div>
        </>
    );
}

export default UseTools;
